import {
    PrismicRichText,
    useFirstPrismicDocument,
  } from "@prismicio/react";

const Page = () => {
    const [document] = useFirstPrismicDocument('Homepage');
    
    return <div>
        {document && (
            <PrismicRichText
            field={document.data.headline}
            />
      )}
    </div>;
};

export default Page;